<script setup lang="ts">
import { defineProps } from "vue";
import CircleComponent from "@/views/Calculators/DestinyMatrix/components/CircleComponent.vue";

defineProps<{
  firstLabel: string;
  secondLabel: string;
  firstValue: string | number;
  secondValue: string | number;
  sumValue: string | number;
}>();
</script>

<template>
  <div
    class="grid grid-cols-[repeat(4,max-content)] grid-rows-2 items-center gap-1 pt-2"
  >
    <p>{{ firstLabel }}</p>
    <CircleComponent :value="firstValue" />
    <img
      src="@/assets/calculators/destiny-matrix/sum.webp"
      class="row-span-2"
      alt="sum"
    />
    <CircleComponent class="row-span-2" :value="sumValue" />
    <p>{{ secondLabel }}</p>
    <CircleComponent :value="secondValue" class="justify-self-center" />
  </div>
</template>
